import { useEffect, useState } from "react";
import ProductRecentSearches from "./ProductRecentSearches";
import ProductSavedSearches from "./ProductSavedSearches";
import { getProductSearchHistory } from "./services";
import type { ProductSearchHistoryResponse, RecentSearchRow, SavedSearchRow } from "./types";

type ProductSearchEmptyStateProps = {
  onReloadRecent: (row: RecentSearchRow) => void;
  onReloadSaved: (row: SavedSearchRow) => void;
};

const ProductSearchEmptyState = ({ onReloadRecent, onReloadSaved }: ProductSearchEmptyStateProps) => {
  const [history, setHistory] = useState<ProductSearchHistoryResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchHistory = async () => {
    setIsLoading(true);
    try {
      const data = await getProductSearchHistory();
      setHistory(data);
    } catch {
      setHistory(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <div className="tw-h-[calc(100vh-170px)] tw-py-[5vh]">
      <div className="tw-flex tw-h-full tw-gap-5 tw-w-[980px] tw-mx-auto">
        <div className="tw-w-1/2 tw-h-full tw-flex tw-flex-col">
          <div className="tw-text-sm tw-font-semibold tw-mb-2 tw-flex tw-items-center tw-gap-2">
            <div className="tw-w-7 tw-h-7 tw-rounded-[6px] tw-bg-primary-purple-50 tw-flex tw-items-center tw-justify-center tw-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#7143f1">
                <path d="m618.92-298.92 42.16-42.16L510-492.16V-680h-60v212.15l168.92 168.93ZM480.07-100q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Z" />
              </svg>
            </div>
            Recent Searches
          </div>
          <ProductRecentSearches recentSearchData={history?.recentSearchResponse} isLoading={isLoading} onReload={onReloadRecent} />
        </div>
        <div className="tw-w-1/2 tw-flex tw-flex-col tw-h-full">
          <div className="tw-text-sm tw-font-semibold tw-mb-2 tw-flex tw-items-center tw-gap-2">
            <div className="tw-w-7 tw-h-7 tw-rounded-[6px] tw-bg-saved-icon-bg tw-flex tw-items-center tw-justify-center tw-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#617cff">
                <path d="M220-150v-597.69Q220-778 241-799q21-21 51.31-21h375.38Q698-820 719-799q21 21 21 51.31V-150L480-261.54 220-150Z" />
              </svg>
            </div>
            Saved Searches
          </div>
          <ProductSavedSearches savedSearchData={history?.saveSearchResponse} isLoading={isLoading} onReload={onReloadSaved} onDeleted={fetchHistory} />
        </div>
      </div>
    </div>
  );
};

export default ProductSearchEmptyState;
